// extracted by mini-css-extract-plugin
module.exports = {"button":"profile-logout_button__xo1tq","buttonText":"profile-logout_buttonText__WDjn_","buttonIcon":"profile-logout_buttonIcon__ieJut"};